import { Box } from "@mui/material";
import { companyManagementUrl } from "../../../config";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";
import DIYForm from "./form";

const base_url = companyManagementUrl.uri;
const ignoreFields = [
  "ContactEmail",
  "CompanyEmail",
  "ContactPhoneNumber",
  "ContactEmailPassword",
  "EmailClient",
  "EmailDisplayName",
  "EmailClientPortNumber",
  "ParentOffice",
  "ContactPerson",
  "PostalAddress",
  "OpeningDate",
  "SMSReminder",
  "PaymentReply",
  "RegistrationFee",
  "GroupRegistrationFee",
  "FSApiKey",
  "SubscriptionId",
  "LogoPath",
  "ApiKey",
  "SMSAccount",
  "TagLine",
  "ExtraSmsConfig",
  "SubscriptionAccount"
];
const actions = {
  entity: "DIYCompanies",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: false,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  dataObject: {
    ignoreFields,
    objectName: "diyCompanies",
    parameters: "",
  },
  showStatus: true,
  showMore:{
    search:false,
    min: 0,
    max:0
  }
};
function DIYTable() {
  return (
    <Box m="2px">
      <>
        <DynamicTableForJson
          title="DIY Companies"
          subtitle="View or Edit Trial Days"
          FormComponent={DIYForm}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default DIYTable;
